export default __webpack_public_path__ + "static/media/RedFace.2f177c33.gif";